import {css} from 'lit';
export const styles = css`:host {
  --border-radius: 8px;

  display: grid;
}

:host([col='1']) {
  grid-template-columns: 1fr;
}

:host([col='2']) {
  grid-template-columns: repeat(2, 1fr);
}

:host([col='3']) {
  grid-template-columns: repeat(3, 1fr);
}

:host([col='4']) {
  grid-template-columns: repeat(4, 1fr);
}

:host([col='5']) {
  grid-template-columns: repeat(5, 1fr);
}

:host([gap='xs']) {
  gap: 2px;
}

:host([gap='sm']) {
  gap: 4px;
}

:host([gap='md']) {
  gap: 8px;
}

:host([gap='lg']) {
  gap: 16px;
}

:host([gap='xl']) {
  gap: 32px;
}

/* Shared by all rounded grids */

:host([rounded='true']) ::slotted(*) {
    overflow: hidden;
  }

:host([rounded='true']) ::slotted(*:first-child) {
    border-top-left-radius: var(--border-radius);
  }

:host([rounded='true']) ::slotted(*:last-child) {
    border-bottom-right-radius: var(--border-radius);
  }

/* Round the top corner of last item in row 1  */

:host([rounded='true'][col='1']) ::slotted(*:nth-child(1)) {
    border-top-right-radius: var(--border-radius);
  }

:host([rounded='true'][col='2']) ::slotted(*:nth-child(2)) {
    border-top-right-radius: var(--border-radius);
  }

:host([rounded='true'][col='3']) ::slotted(*:nth-child(3)) {
    border-top-right-radius: var(--border-radius);
  }

:host([rounded='true'][col='4']) ::slotted(*:nth-child(4)) {
    border-top-right-radius: var(--border-radius);
  }

:host([rounded='true'][col='5']) ::slotted(*:nth-child(5)) {
    border-top-right-radius: var(--border-radius);
  }

/* Round the remaining corners of a SHORT GRID (doesn't fill a single row) */

:host([rounded='true'][imperfection='-1']) ::slotted(*:first-child) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='-1']) ::slotted(*:last-child) {
    border-top-right-radius: var(--border-radius);
  }

/* Round the remaining corner of PERFECT GRIDS (all rows are full) */

:host([rounded='true'][imperfection='0'][col='1']) ::slotted(*:nth-last-child(1)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='0'][col='2']) ::slotted(*:nth-last-child(2)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='0'][col='3']) ::slotted(*:nth-last-child(3)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='0'][col='4']) ::slotted(*:nth-last-child(4)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='0'][col='5']) ::slotted(*:nth-last-child(5)) {
    border-bottom-left-radius: var(--border-radius);
  }

/* Round the remaining corners of IMPERFECT GRIDS (last row not full) - has 1 more rounded corner than others  */

:host([rounded='true'][imperfection='1']) ::slotted(*:nth-last-child(1)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='1']) ::slotted(*:nth-last-child(2)) {
    border-bottom-right-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='2']) ::slotted(*:nth-last-child(2)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='2']) ::slotted(*:nth-last-child(3)) {
    border-bottom-right-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='3']) ::slotted(*:nth-last-child(3)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='3']) ::slotted(*:nth-last-child(4)) {
    border-bottom-right-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='4']) ::slotted(*:nth-last-child(4)) {
    border-bottom-left-radius: var(--border-radius);
  }

:host([rounded='true'][imperfection='4']) ::slotted(*:nth-last-child(5)) {
    border-bottom-right-radius: var(--border-radius);
  }
`;
export default styles;
